<template>
  <v-container fluid>
    <v-row dense class="mt-1">
      <v-col cols="12">
        <span class="text-h6"> {{ $t('header') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.ticketNumber"
          :label="$t('ticketNumber')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.setting"
          :label="$t('setting')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.tract"
          :label="$t('tract')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.destination"
          :label="$t('destination')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.contractAccount"
          :label="$t('contractAccount')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.product"
          :label="$t('product')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.weighedOutAt"
          :label="$t('weighedOutAt')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.inWeight"
          :label="$t('inWeight')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.outWeight"
          :label="$t('outWeight')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.netWeight"
          :label="$t('netWeight')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.trailerIdentifier"
          :label="$t('trailerIdentifier')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="text-h6"> {{ $t('logs') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.species"
          :label="$t('species')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.buttLog"
          :label="$t('buttLog')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="subtitle-1"> {{ $t('segmentOne') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneGrade"
          :label="$t('segmentOneGrade')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneEndUseSort"
          :label="$t('segmentOneEndUseSort')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneLength"
          :label="$t('segmentOneLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneDiameter"
          :label="$t('segmentOneDiameter')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneGrossVolume"
          :label="$t('segmentOneGrossVolume')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneNetVolume"
          :label="$t('segmentOneNetVolume')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneDefectVolume"
          :label="$t('segmentOneDefectVolume')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="subtitle-1"> {{ $t('segmentTwo') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoGrade"
          :label="$t('segmentTwoGrade')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoEndUseSort"
          :label="$t('segmentTwoEndUseSort')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoLength"
          :label="$t('segmentTwoLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoDiameter"
          :label="$t('segmentTwoDiameter')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoGrossVolume"
          :label="$t('segmentTwoGrossVolume')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoNetVolume"
          :label="$t('segmentTwoNetVolume')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoDefectVolume"
          :label="$t('segmentTwoDefectVolume')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="subtitle-1"> {{ $t('segmentThree') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeLength"
          :label="$t('segmentThreeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeDiameter"
          :label="$t('segmentThreeDiameter')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeGrossVolume"
          :label="$t('segmentThreeGrossVolume')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeNetVolume"
          :label="$t('segmentThreeNetVolume')"
          outlined
          readonly
          color="black"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ScaleSheetImportCsvProfileDetail',

  props: {
    propProfile: {
      type: Object,
      required: true
    }
  }
}
</script>
